import { inject, Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { FeatureFlagService } from '../../shared/misc-services/feature-flag.service';
import { AbstractResource } from '../abstract-resource';

@Injectable()
export class FeatureFlagLoadingService extends AbstractResource {
  private featureFlagService = inject(FeatureFlagService);

  async load() {
    const { projectId, user } = this.workspaceConfig;
    const featureFlags = await lastValueFrom(
      this.request$<string[]>('GET', featureFlagsPath(user.id), {
        cache: true,
        customErrorMessage: 'Failed to load feature flags.',
        params: { project_id: projectId.toString() },
        tokenScope: 'sama-lab',
      }),
    );

    // should be moved to the store and treated like a regular model eventually
    this.featureFlagService.setFlags(featureFlags);
  }
}

export function featureFlagsPath(agentId: number) {
  return `${environment.featureFlagServiceBaseUrl}/agents/${agentId}/experiments`;
}
